exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.block[data-v-4ab0fbf8] {\r\n  padding: 1.5rem 1.5rem 0;\n}\n.block__form__actions__back[data-v-4ab0fbf8] {\r\n  margin: 0 0 1rem 0;\r\n  padding: 0.5rem 0 1rem 0;\n}\n.sub-label[data-v-4ab0fbf8] {\r\n  display: block;\r\n  font-size: 0.8125rem;\r\n  margin-top: 0.4375rem;\r\n  margin-top: -30px;\r\n  margin-bottom: 35px;\n}\n.label_code[data-v-4ab0fbf8] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  width: 100%;\n}\r\n", ""]);

// exports
